import { createContext } from 'react';

import { ChartInteractionsConfig } from '../../core/types/interactions.js';

export const TimeseriesInteractionsContext =
  createContext<ChartInteractionsConfig>({});

TimeseriesInteractionsContext['displayName'] = 'TimeseriesInteractionsContext';
